import React from 'react'
import styled from 'styled-components'

function TermsOfUse() {
  return (
    <Container>
        <h1>MarketLab Terms of Use</h1>


        <h2>Acceptance of Terms</h2>
        <p>Welcome to MarketLab! By accessing or using our services, you agree to be bound by these Terms of Use. 
        If you do not agree with any part of these terms, you may not use our services.</p>

        <h2>Description of Services</h2>
        <p>
        MarketLab provides software solutions to help businesses with their marketing efforts, including but not limited to SEO tools, 
        analytics, and other digital marketing aids. Our services are available through our website and various applications.
        </p>

        <h2>Eligibility</h2>
        <p>
        To use MarketLab, you must be at least 18 years old and capable of forming a binding contract with us. 
        By using our services, you represent and warrant that you meet these requirements.
        </p>

        <h2>Account Registration</h2>
        <p>
        You may need to create an account to access certain features of our services. You agree to provide accurate, complete, and up-to-date information during the registration process. 
        You are responsible for safeguarding your account information and are liable for all activities conducted through your account.
        </p>

        <h2>Subscription and Fees</h2>
        <p>
        MarketLab offers both free and paid subscription plans. The features and fees of each plan are described on our pricing page. By subscribing to a paid plan, you agree to pay the specified fees. 
        We reserve the right to change our subscription plans and fees at any time. 
        <strong>Please note that all payments, including subscription fees, are non-refundable at this time. However, we are actively working on implementing a refund system, which will be available in the future.</strong>
        </p>

        <h2>Payment and Nexilum Units</h2>
        <p>
        In addition to subscription plans, MarketLab offers the ability to purchase Nexilum units for occasional use. All payments for subscriptions and Nexilum units must be made via the payment methods provided on our platform. 
        You agree to pay all applicable fees in connection with your purchase. <strong>Please note that all payments, including subscription fees, are non-refundable at this time. However, we are actively working on implementing a refund system, which will be available in the future.</strong>.
        </p>

        <h2>Use of Services</h2>
        <p>
        You agree to use MarketLab in compliance with all applicable laws and regulations. You must not:
        <ul>
        <li>Use our services for any illegal or unauthorized purpose.</li>
        <li>Interfere with or disrupt the integrity or performance of our services.</li>
        <li>Attempt to gain unauthorized access to our systems or networks.</li>
        </ul>
        </p>

        <h2>Intellectual Property</h2>
        <p>
        All content, features, and functionality of MarketLab, including but not limited to text, graphics, logos, and software, are the exclusive property of MarketLab and are protected by international copyright, 
        trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
        </p>

        <h2>User Content</h2>
        <p>
        By submitting any content to MarketLab, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and distribute your content in connection with our services. 
        You represent and warrant that you own or have the necessary rights to the content you submit.
        </p>

        <h2>Privacy Policy</h2>
        <p>
        Your use of MarketLab is also governed by our Privacy Policy, which describes how we collect, use, and disclose your personal information. 
        By using our services, you agree to our Privacy Policy.
        </p>

        <h2>Termination</h2>
        <p>
        We may terminate or suspend your access to our services immediately, without prior notice or liability, for any reason, including if you breach these Terms of Use. 
        Upon termination, your right to use our services will immediately cease.
        </p>

        <h2>Disclaimer of Warranties</h2>
        <p>
        MarketLab is provided on an "as is" and "as available" basis. We make no warranties, express or implied, regarding the operation or availability of our services, 
        or the accuracy, reliability, or completeness of any content provided.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
        In no event shall MarketLab be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, 
        or other intangible losses, arising out of or in connection with your use of our services.
        </p>

        <h2>Governing Law</h2>
        <p>
        These Terms of Use shall be governed and construed in accordance with the laws of Netherlands, without regard to its conflict of law provisions.
        </p>

        <h2>Changes to Terms of Use</h2>
        <p>
        We reserve the right to modify these Terms of Use at any time. If we make material changes, we will provide notice through our services or by other means. 
        Your continued use of our services after the effective date of any changes constitutes your acceptance of the new Terms of Use.
        </p>

        <h2>Contact Us</h2>
        <p>
        If you have any questions about these Terms of Use, please contact us at support@improwth.com or reach@improwth.com.
        </p>

        <div style={{height: '100px', marginBlock: '50px'}}/>
    </Container>
  )
}

export default TermsOfUse


const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    background-color: #f2f2f2;
    padding: 25px 0 0 15px;
    overflow-x: hidden;
    overflow-y: scroll;


    > h1 {
        font-weight: 300;
        margin-bottom: 50px;
    }

    > h2 {
        font-weight: 300;
        margin-bottom: 10px;
    }

    > p {
        width: 70%;
        margin-bottom: 20px;

        > ul > li {
            margin-left: 20px;
        }
    }
`